import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import styled from "styled-components";
import placeholder from "../../assets/placeholder-cast.jpg";
import { Link } from "react-router-dom";

function Cast({ title, movieId, api }) {
	const [casts, setCast] = useState([]);
	const tvCast = `/tv/${movieId}/credits?api_key=${api}&language=en-US`;
	const movieCast = `/movie/${movieId}/credits?api_key=${api}&language=en-US`;
	const base_url = "https://image.tmdb.org/t/p/original";

	const Member = styled.div`
		flex: 0 0 200px;
		max-width: 200px;

		.cast-img {
			img {
				max-height: 300px;
				min-height: 300px;
				object-fit: cover;
				object-position: center;
			}
		}
		.cast-info {
			// background-color: #fff;
			padding: 10px;
			text-align: center;

			a {
				text-decoration: none;
			}
			h3 {
				color: #fff;
				font-size: 1.2rem;
				margin-bottom: 5px;
			}
			.character {
				color: #ccc;
				font-size: 0.9rem;
			}
		}
	`;

	useEffect(() => {
		async function getCast() {
			try {
				let request = await axios.get(movieCast);
				setCast(request.data, "Movie");
				return request;
			} catch (err) {
				if (err.response) {
					let request = await axios.get(tvCast);
					setCast(request.data);
					return request;
				} else {
					console.log("No Movie found?");
				}
			}
		}
		getCast();
	}, [movieCast, tvCast]);

	return (
		casts.cast?.length && (
			<div className="row">
				<h2>{title}</h2>
				<div className="row__posters casts">
					{casts &&
						casts.cast?.map((cast) => (
							<Member
								className="cast-member movie-item"
								key={cast.id}
							>
								<div className="cast-img">
									{cast?.profile_path ? (
										<Link to={`/actor/${cast.id}`}>
											{" "}
											<img
												src={`${base_url}${cast?.profile_path}`}
												alt={cast?.character}
											/>
										</Link>
									) : (
										<Link to={`/actor/${cast.id}`}>
											<img
												src={placeholder}
												alt={cast?.character}
											/>
										</Link>
									)}
								</div>
								<div className="cast-info">
									<Link to={`/actor/${cast.id}`}>
										<h3>
											{cast?.name || cast?.original_name}
										</h3>
									</Link>
									<div className="character">
										{cast?.character}
									</div>
								</div>
							</Member>
						))}
				</div>
			</div>
		)
	);
}

export default Cast;
